import React, { Fragment } from "react";
import { InputTextarea } from "primereact/inputtextarea";

const InputFieldTextarea = ({
  handler,
  variables: { value, disabled, showError },
  constants: { label, medSize, id, textError, name, rows, cols },
}) => {
  return (
    <Fragment>
      <div className={`p-field p-col-4 p-md-${medSize}`}>
        <label htmlFor={id}>{label}</label>
        <InputTextarea
          id={id}
          name={name}
          value={value}
          onChange={handler}
          disabled={disabled}
          rows={rows}
          cols={cols}
          aria-describedby={`${id}-help`}
          className={showError && "p-invalid p-d-block"}
        />
        {showError && (
          <small id={`${id}-help`} className='p-invalid p-d-block'>
            {textError}
          </small>
        )}
      </div>
    </Fragment>
  );
};

export default InputFieldTextarea;
